import React from 'react';
import Header from '../../components/Header';

const Girls = () => {
    return (
        <div>
            <Header />
        </div>
    );
};

export default Girls;